import { render, staticRenderFns } from "./AssignUsers.vue?vue&type=template&id=381f387d&"
import script from "./AssignUsers.vue?vue&type=script&lang=js&"
export * from "./AssignUsers.vue?vue&type=script&lang=js&"
import style0 from "./AssignUsers.vue?vue&type=style&index=0&id=381f387d&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('381f387d')) {
      api.createRecord('381f387d', component.options)
    } else {
      api.reload('381f387d', component.options)
    }
    module.hot.accept("./AssignUsers.vue?vue&type=template&id=381f387d&", function () {
      api.rerender('381f387d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FunctionBox/AssignUsers.vue"
export default component.exports